import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { Fragment } from 'react';

import ContactInfoField from './contactInfoField';
import type { ContactInfoProps } from './index';

const Contact = ({
  billingContactEditForm,
  isAdmin,
  onUpdateFormField,
  showValidationErrors,
  validationErrors,
}: ContactInfoProps) => (
  <Fragment>
    <h2 className='margin-left-sm margin-bottom-xs' data-ref='buydot.contact-info.billing-contact-header'>
      {t('client.headings.billing-contact')}
    </h2>
    <h3 className='margin-left-sm pad-bottom-sm' data-ref='buydot.contact-info.billing-contact-sub-header'>
      {t('client.headings.contact-info')}
    </h3>
    <SRow class='pad-bottom-none'>
      <SCol span='3'>
        <ContactInfoField
          disabled={!isAdmin}
          displayName={t('client.labels.first-name')}
          fieldName='FirstName'
          fieldValue={billingContactEditForm.FirstName}
          required={true}
          showValidationErrors={showValidationErrors}
          onUpdateFormField={onUpdateFormField}
          validationError={validationErrors.FirstName}
        />
      </SCol>
      <SCol span='3'>
        <ContactInfoField
          disabled={!isAdmin}
          displayName={t('client.labels.last-name')}
          fieldName='LastName'
          fieldValue={billingContactEditForm.LastName}
          required={true}
          showValidationErrors={showValidationErrors}
          onUpdateFormField={onUpdateFormField}
          validationError={validationErrors.LastName}
        />
      </SCol>
    </SRow>
    <SRow>
      <SCol span='6' class='pad-bottom-sm'>
        <ContactInfoField
          disabled={!isAdmin}
          displayName={t('client.labels.email-address')}
          fieldName='WorkEmail'
          fieldValue={billingContactEditForm.WorkEmail}
          required={true}
          showValidationErrors={showValidationErrors}
          onUpdateFormField={onUpdateFormField}
          validationError={validationErrors.WorkEmail}
        />
        <ContactInfoField
          disabled={!isAdmin}
          displayName='Alternate email address'
          fieldName='PersonalEmail'
          fieldValue={billingContactEditForm.PersonalEmail}
          required={false}
          showValidationErrors={showValidationErrors}
          onUpdateFormField={onUpdateFormField}
          validationError={validationErrors.PersonalEmail}
          validationName='email address'
        />
      </SCol>
    </SRow>
    <SRow>
      <SCol span='3'>
        <ContactInfoField
          disabled={!isAdmin}
          displayName={t('client.labels.phone')}
          fieldName='WorkPhone'
          fieldValue={billingContactEditForm.WorkPhone}
          placeholder='1234567890'
          required={true}
          showValidationErrors={showValidationErrors}
          onUpdateFormField={onUpdateFormField}
          validationError={validationErrors.WorkPhone}
          validationName='phone number'
        />
      </SCol>
      <SCol span='3'>
        <ContactInfoField
          disabled={!isAdmin}
          displayName='Alternate phone'
          fieldName='MobilePhone'
          fieldValue={billingContactEditForm.MobilePhone}
          required={false}
          showValidationErrors={showValidationErrors}
          onUpdateFormField={onUpdateFormField}
          validationError={null}
        />
      </SCol>
    </SRow>
  </Fragment>
);

export default Contact;
